import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useContext, useEffect, useState } from 'react';
import { TenantConfigContext } from 'context/TenantConfigContext';

export const TRADING_ROOT = '/steeringhub/insightsfeed';

export function Trading() {
  const [lastAccountNumber, setLastAccountNumber] = useState<string>();

  const { accountNumber } = useContext(TenantConfigContext);
  const navigate = useNavigate();
  const { search } = useLocation();

  useEffect(() => {
    if (accountNumber) {
      if (lastAccountNumber && accountNumber !== lastAccountNumber) {
        navigate(`${TRADING_ROOT}${search}`);
      }
      setLastAccountNumber(accountNumber);
    }
  }, [accountNumber]);

  return (
    <div className="steeringhub">
      <Outlet />
    </div>
  );
}
